import { PointTwoComment } from "../BisControlCards";
import { ProductionDossierAttachments } from "../ProductionBlocks";
import { PATIENT_CONTROL_INSTRUCTIONS, VARIANT } from "../bisVariant";
import { BlockingPatientIssuesForPoint } from "../../shared/components/BlockingPatientIssuesForPoint";
import { ControlPointInstruction } from "../../shared/components/ControlPointInstruction";
import { PointComment } from "../../shared/components/PointComment";

// Commentaires simples de la check-list pré-production : clé enregistrée dans formData.commentaires et intitulé.
export const BIS_POINT_COMMENTS = {
    fspMduHp: { key: "fspMduHpEureka", title: "Sur planificateur : Vérification des FSP et MDU et ce qui apparaît en HP:" },
    rappelsProduction: { key: "validationRetraitsPreProduction", title: "Validation des retraits de lot:" },
    ruptures: {
        key: "rupturesMedicament",
        title: "Validation des Ruptures de Médicament : S'assurer que toutes les ruptures de médicaments sont documentées et validées:",
    },
    sortiesCassettes: { key: "sortiesMedicamentsArretesRompus", title: "Sorties des Médicaments Arrêtés / Rompus des cassettes:" },
    retraitsLots: { key: "validationRetraitsLots", title: "Validation des Retraits de Lots:" },
};

const PATIENT_POINT_KEYS = ["tracageLogiciels", "datesProduction", "posologies"];

function renderPatientPointAction(view, rowKey, pointColor, sectionLocked) {
    const { blockingPatientIssues, updatePatientLaunchStatus, updatePatientSharedControlComment } = view;
    return (
        <>
            <ControlPointInstruction text={PATIENT_CONTROL_INSTRUCTIONS[rowKey]} pointColor={pointColor} />
            <BlockingPatientIssuesForPoint
                launchStatusLabels={VARIANT.launchStatusLabels}
                issues={blockingPatientIssues.filter(issue => issue.pointKey === rowKey)}
                onCommentChange={(patientId, _pointKey, comment) => updatePatientSharedControlComment(patientId, comment)}
                onLaunchStatusChange={rowKey === "tracageLogiciels"
                    ? (patientId, pointKey, launchStatus) => updatePatientLaunchStatus(patientId, launchStatus)
                    : undefined}
                disabled={sectionLocked}
            />
        </>
    );
}

function renderImportAction(view, pointColor, sectionLocked) {
    const { updateCommentaire, user, workspace } = view;
    const commentaires = workspace.formData.commentaires || {};
    return (
        <PointTwoComment
            value={commentaires.importEureka || ""}
            validation={commentaires.importEurekaValidation || {}}
            pointColor={pointColor}
            onChange={(value) => updateCommentaire("importEureka", value)}
            onValidationChange={(validated) => updateCommentaire("importEurekaValidation", validated ? {
                validatedAt: new Date().toISOString(),
                validatedBy: user?.username || user?.email || "",
            } : {})}
            disabled={sectionLocked}
        />
    );
}

function renderFillingNeedsAction(view, pointColor, sectionLocked) {
    const { updateCommentaire, uploadPreProductionPoint6Attachment, workspace } = view;
    return (
        <div style={{ display: "grid", gap: "12px" }}>
            <PointComment
                title="Importer tableau des Besoins de Remplissage cassette:"
                value={workspace.formData.commentaires?.besoinsRemplissageCassette || ""}
                pointColor={pointColor}
                onChange={(value) => updateCommentaire("besoinsRemplissageCassette", value)}
                disabled={sectionLocked}
            />
            <ProductionDossierAttachments
                dossierId={workspace.activeDossier.id}
                attachments={(workspace.formData.piecesJointes || []).filter(attachment => attachment.section === "preprodPoint6")}
                uploading={workspace.attachmentUploading}
                onUpload={uploadPreProductionPoint6Attachment}
                onDelete={workspace.deleteAttachment}
                emptyLabel="Aucune pièce jointe pour le point 6."
            />
        </div>
    );
}

export function renderControlPointAction(view, rowKey, pointColor, sectionLocked) {
    if (PATIENT_POINT_KEYS.includes(rowKey)) return renderPatientPointAction(view, rowKey, pointColor, sectionLocked);
    if (rowKey === "importEureka") return renderImportAction(view, pointColor, sectionLocked);
    if (rowKey === "besoinsRemplissage") return renderFillingNeedsAction(view, pointColor, sectionLocked);
    const comment = BIS_POINT_COMMENTS[rowKey];
    if (!comment) return null;
    return (
        <PointComment
            title={comment.title}
            value={view.workspace.formData.commentaires?.[comment.key] || ""}
            pointColor={pointColor}
            onChange={(value) => view.updateCommentaire(comment.key, value)}
            disabled={sectionLocked}
        />
    );
}
